import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["w-full select-none justify-center items-center cursor-pointer focus:outline-none hover:bg-primary-50 dark:hover:bg-dark-400", {
      'text-primary': _ctx.isDisabled,
      'text-aoj dark:text-dark-text-dark': !_ctx.isDisabled,
      'py-4 px-1': _ctx.displayHeight >= 840,
      'py-2 px-2': _ctx.displayHeight < 840
    }]),
    disabled: _ctx.isDisabled,
    style: {"transition":"background-color 0.25s"},
    onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)), ["exact","prevent"]), ["enter"]))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["material-icons", _ctx.displayHeight >= 840 ? 'text-4xl' : 'text-2xl'])
    }, _toDisplayString(_ctx.icon), 3),
    _createElementVNode("div", {
      class: "text-sm font-bold",
      style: _normalizeStyle({ fontSize: _ctx.displayHeight >= 840 ? '14px' : '10px' })
    }, _toDisplayString(_ctx.text), 5)
  ], 42, _hoisted_1))
}